import { observerEpicHelper } from 'epics/helpers'
import { updateAppUrl } from 'lib/url/route'
import { DEFAULT_APP, DEFAULT_URL } from '../helpers/constants'
import { Constants } from '../actions'
export const navigateToCollectionTypeEpic = observerEpicHelper(
  [Constants.NAVIGATE_TO_COLLECTION_TYPE],
  async ({ action, observer, store }) => {
    const collectionType = action.payload
    const app = `${DEFAULT_APP}?collection_types=${collectionType}`
    const href = `${DEFAULT_URL}/${collectionType}`
    updateAppUrl({
      app,
      href,
    })
    observer.complete()
  }
)
export default [navigateToCollectionTypeEpic]